import React from 'react'
import type { Icon } from 'shared/utils'

const Geolocation = (props: Icon) => {
    const { color = 'black', size = 24, className = 'geolocation' } = props
    return (
        <svg
            className={className}
            width={size}
            height={size}
            fill={color}
            viewBox="0 0 24 24"
            preserveAspectRatio="none">
            <path d="M18.595 11.818a6.132 6.132 0 0 0-5.413-5.413V5h-1.364v1.405a6.132 6.132 0 0 0-5.413 5.413H5v1.364h1.405a6.132 6.132 0 0 0 5.413 5.413V20h1.364v-1.405a6.132 6.132 0 0 0 5.413-5.413H20v-1.364h-1.405zM12.5 17.273A4.77 4.77 0 0 1 7.727 12.5 4.77 4.77 0 0 1 12.5 7.727a4.77 4.77 0 0 1 4.773 4.773 4.77 4.77 0 0 1-4.773 4.773z" />
        </svg>
    )
}

export { Geolocation }
